// import { resolve } from 'core-js/fn/promise';
import Vue from 'vue';
import Router from 'vue-router';
import Cookies from 'js-cookie'
import { Message } from "element-ui"

Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect: '/index',
    name: 'Index',
    component: () => import('../layouts/index'),
    meta: {
      title: '首页'
    },
    children: [
      {
        path: '/index',
        name: 'Index',
        component: () => import('@/views/index'),
        meta: {
          title: '首页',
        },
      },
    ],
  },
  {
    path: '/screen',
    redirect: '/screen',
    name: 'Screen',
    component: () => import('../layouts/index'),
    meta: {
      title: '数据概览'
    },
    children: [
      {
        path: '/screen',
        component: () => import('@/views/screen/index'),
      },
    ],
  },
  {
    path: '/',
    name: 'Main',
    component: () => import('../layouts/main'),
    children: [
      // {
      //   path: '/generate',
      //   name: 'Generate',
      //   component: () => import('@/views/generate/info'),
      //   meta: {
      //     title: '条码生成',
      //   },
      // },
      {
        path: '/generateInfo',
        name: 'GenerateInfo',
        component: () => import('@/views/generate/index'),
        meta: {
          title: '条码生成',
        },
      },
      {
        path: '/print',
        name: 'Print',
        component: () => import('@/views/print/index'),
        meta: {
          title: '条码打印',
        },
      },
      {
        path: '/mybarcode',
        name: 'MyBarcode',
        component: () => import('@/views/mybarcode/index'),
        meta: {
          title: '我的条码',
        },
      },
      {
        path: '/product',
        name: 'Product',
        component: () => import('@/views/product/index'),
        meta: {
          title: '物料管理',
        },
      },
      {
        path: '/setup',
        name: 'SetUp',
        component: () => import('@/views/setup/index'),
        meta: {
          title: '设置',
        },
      },
      {
        path: '/personalCenter',
        name: 'PersonalCenter',
        component: () => import('@/views/personalCenter/index'),
        meta: {
          title: '个人中心',
        },
      },
      {
        path: '/templateEdit',
        name: 'TemplateEdit',
        component: () => import('@/views/setup/template-edit'),
        meta: {
          title: '编辑模版',
        },
      },
      {
        path: '/productDetail',
        name: 'ProductDetail',
        component: () => import('@/views/mall/detailInfo'),
        meta: {
          title: '购买',
        },
      },
    ],
  },
  // {
  //   path: '/login',
  //   name: 'Login',
  //   component: () => import('../layouts/layout-login'),
  //   meta: {
  //     title: '登录'
  //   },
  //   children: [
  //     {
  //       path: '/login',
  //       name: 'Login',
  //       component: (resolve) => require(['@/views/login'], resolve),
  //       meta: {
  //         title: '登录',
  //       },
  //     },
  //   ],
  // },
  {
          path: '/login',
          name: 'Login',
          component: (resolve) => require(['@/views/login'], resolve),
          meta: {
            title: '登录',
          },
        },
  {
    path: '/supplierreg',
    name: 'Supplierreg',
    component: () => import('@/views/supplierreg'),
    meta: {
      title: '供方注册',
    },
  },
  {
    path: '/404',
    name: 'Err404',
    component: () => import('../views/error/404'),
    meta: {
      title: '404'
    },
  },
  {
    path: '/401',
    name: 'Err401',
    component: () => import('../views/error/401'),
    meta: {
      title: '401'
    },
  },
  { // 全不匹配的情况下，返回404，路由按顺序从上到下，依次匹配。最后一个*能匹配全部，
    path: '*',
    component: () => import('../views/error/404'),
  },
]

const router = new Router({
  mode: 'history',
  routes
})

const originalPush = Router.prototype.push
// 修改 原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err=>err)
}

router.beforeEach((to, from, next) => {
  const expiresState = Cookies.get('ExpiresState')?JSON.parse(Cookies.get('ExpiresState')):false
  if(to.path === '/'||to.path === '/index') {
    return next()
  } else {
    if (expiresState) {
      Message({
        message: '帐号授权已到期，请联系管理员！',
        type: 'error',
        showClose: true,
        offset: 145,
      })
      next({ name : 'Index'})
    } else {
      next()
    }
  }
})

export default router
